import { combineReducers } from '@reduxjs/toolkit';
import createSubjectDoctorLogReducer from './create-subject-doctor-log';
import getSubjectDoctorLogListReducer from './get-subject-doctor-log-list';
import updateSubjectDoctorLogReducer from './update-subject-doctor-log';

const subjectDoctorLogReducer = combineReducers({
  createSubjectDoctorLog: createSubjectDoctorLogReducer,
  getSubjectDoctorLogList: getSubjectDoctorLogListReducer,
  updateSubjectDoctorLog: updateSubjectDoctorLogReducer
});

export default subjectDoctorLogReducer;